var map = {
	"./bed.png": 3087,
	"./bex.png": 5512,
	"./brownsof.png": 356,
	"./chan.png": 3882,
	"./dini.png": 2260,
	"./livin.png": 6811,
	"./resof.png": 8045,
	"./sof.png": 9734,
	"./stan.png": 4918,
	"./tach.png": 966,
	"./tv.png": 646,
	"./whites.png": 8044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4099;